import React from 'react';
import { IslandButton, TrevorIcon } from '@trevor/ui-components';

export const Cohort = () => (
  <IslandButton
    content={<TrevorIcon name="cohort" />}
    tooltipContent=" Cohort analysis - coming soon!"
    $disabled
  />
);
